import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Grid, GridElement } from './grid';
import { IconButton } from './icon';
import { themes } from './theme';


const StyledHeader = styled.div<{animate : boolean}>`
    font-family: 'Montserrat', sans-serif;
    background: transparent;
    width: 100%;
    transition: all 0.3s ease;
    z-index: 9999;
    position: fixed;
    height: 5vh;
    top: 0;
    padding: 1rem;

  ${(props) =>
    props.animate && `
        background: ${themes.background.main};
  `}
`;

const StyledHeaderLogo =styled.a<{animate:boolean}>`
    color: ${themes.primary.main};
    font-size: 2rem;
    transition: all 0.3s ease;
    &:before{
        content: "band name"
    }
    ${(props) =>
        props.animate && `
        font-size: 1.2rem;
            height: 10vh;
            border: 1px white solid;
            padding: 0.5rem;

            &:before{
                content: "tp"
            }
      `}
`;

interface HeaderProps {
    children?: ReactElement;
}

const Header = ({children} : HeaderProps) : ReactElement => {

    const [toggle, setToggle] = useState(false)

    const handleScroll = () => {
        const position = window.scrollY;
        if(position > 70) {
            setToggle(true)
        } else {
            setToggle(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

		return () => {
            window.removeEventListener('scroll', handleScroll);
		};
	}, []);

    return (
        <StyledHeader animate={toggle}>
            <Grid dimension='ab' parts={2}>
                <GridElement position=''>
                    <StyledHeaderLogo animate={toggle} ></StyledHeaderLogo>
                </GridElement>
                <GridElement position=''>
                <Grid parts={4} dimension={"a b c d"}>
                    <GridElement position=''>
                    <IconButton href={""} onClick={() => {}} size='2x' main={true} value={["fab", "spotify"]}/>
                    </GridElement>
                    <GridElement position=''>
                        <IconButton href={""} size='2x' main={true} value={['fab', 'instagram']}/>
                    </GridElement>
                    <GridElement position=''>
                    <IconButton href={""} size='2x' main={true} value={['fab', 'soundcloud']}/>
                    </GridElement>
                    <GridElement position=''>
                    <IconButton href={""}size='2x' main={true} value={['fab', 'facebook']}/>
                    </GridElement>
                </Grid>
                </GridElement>
            </Grid>
        </StyledHeader>
    )
}

export {Header}